<template>
  <div class="notepad-card m-t-sm">
    <div class="flex justify-space-between align-items-baseline">
      <h4 class="m-y-none font-heavy">
        {{ result.author.display_name }}
      </h4>
      <div class="flex gap-x-xs font-small">
        <p class="color-gray-500 m-y-none"><time :datetime="result.created_at" data-local='time-ago'></time></p>
      </div>
    </div>
    <div class="m-t-xxs" v-html="parseMentionable(result.content)"></div>
  </div>
</template>

<script>
import { urlHelperMixin } from './mixins/url_helper_mix';
export default {
  name: 'mentionable',
  props: ['result'],
  mixins: [
    urlHelperMixin
  ],
  methods: {
    truncateUrl(url, maxLength = 50) {
      if (url.length <= maxLength) return url;
      try {
        let urlObj = new URL(url.startsWith('http') ? url : `https://${url}`);
        let domain = urlObj.hostname.replace(/^www\./, '');
        let path = urlObj.pathname + urlObj.search;
        if (domain.length >= maxLength - 3) {
          return domain.substring(0, maxLength - 3) + '...';
        }
        let remaining = maxLength - domain.length - 3;
        if (path.length > remaining && remaining > 0) {
          return domain + path.substring(0, remaining) + '...';
        }
        return domain + path;
      } catch (e) {
        return url.substring(0, maxLength - 3) + '...';
      }
    },
    parseMentionable(text) {
      let urlified = this.urlify(text, false, null);
      // Truncate displayed link text while preserving href
      urlified = urlified.replace(/<a ([^>]*)>([^<]{51,})<\/a>/g, (match, attrs, linkText) => {
        return `<a ${attrs}>${this.truncateUrl(linkText)}</a>`;
      });
      // Only apply video-seeker timestamp replacement to text outside anchor tags
      return urlified.replace(/(<a\s[^>]*>.*?<\/a>)|(\d{0,2}(\d|:)\d{2})/g, (match, anchor, timestamp) => {
        if (anchor) return anchor;
        if (timestamp) return `<a class='video-seeker' href='#${timestamp}'>${timestamp}</a>`;
        return match;
      });
    },
  },
};
</script>
